import React from 'react';
import Typography, { StyledTypographyProps } from '.';

const Subtitle1 = (props: StyledTypographyProps) => {
	return <Typography {...props} variant='subtitle1' />;
};

export default Subtitle1;
